<template>
  <div class="headline-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem label-position="top">
          <Select v-model="formItem.push_type"
                  clearable
                  filterable
                  placeholder="选择推荐类型">
            <Option v-for="item in pushtypelist"
                    :value="item.id"
                    :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.status"
                  clearable
                  style="width:80px"
                  placeholder="请选择状态...">
            <Option v-for="item in statusList"
                    :value="item.id"
                    :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
        <FormItem>
          <Button @click="showModel()"
                  type="success"
                  class="f-r">添加头条</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="columns1"
           ref="selection"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Drawer :title="title"
            v-model="showModalStatus"
            width="1200"
            :mask-closable="false"
            :styles="styles">
      <Form :model="headline"
            label-position="top"
            ref="headlineValidate"
            action="javascript:void(0)">
        <FormItem label="选择推荐类型"
                  label-position="top">
          <Select v-model="headline.push_type"
                  clearable
                  filterable
                  placeholder="选择推荐类型">
            <Option v-for="item in pushtypelist"
                    :value="item.id"
                    :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="头条分类"
                  label-position="top">
          <Select v-model="headline.cate_id"
                  clearable
                  filterable
                  placeholder="选择头条分类">
            <Option v-for="item in catelist"
                    :value="item.f_id"
                    :key="item.f_id">{{item.f_name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="是否推荐">
          <RadioGroup v-model="headline.is_push">
            <Radio :label="0"
                   border>否</Radio>
            <Radio :label="1"
                   border>是</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="展示形式"
                  label-position="top">
          <RadioGroup v-model="headline.type"
                      @on-change="headlinetype">
            <Radio label="0">图+文</Radio>
            <Radio label="1">视频</Radio>
            <Radio label="2">图文</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="名称"
                  v-if="showHeadlineTitle">
          <Input v-model="headline.title"
                 placeholder="请输入标题" />
        </FormItem>
        <FormItem label="省-市-县"
                  label-position="top">
          <Select v-model="headline.area1"
                  placeholder="省"
                  @on-change="shengChange">
            <Option v-for="item in shengList"
                    :value="item.id"
                    :key="item.id">{{item.areaname}}</Option>
          </Select>
        </FormItem>
        <FormItem label=" "
                  label-position="top">
          <Select v-model="headline.area2"
                  placeholder="市"
                  @on-change="shiChange">
            <Option v-for="item in shiList"
                    :value="item.id"
                    :key="item.id">{{item.areaname}}</Option>
          </Select>
        </FormItem>
        <FormItem label=" "
                  label-position="top">
          <Select v-model="headline.area3"
                  placeholder="县">
            <Option v-for="item in quList"
                    :value="item.id"
                    :key="item.id">{{item.areaname}}</Option>
          </Select>
        </FormItem>
        <FormItem label="描述"
                  v-if="showHeadlineDescibe">
          <Input type="textarea"
                 v-model="headline.describe"
                 :rows="3"
                 placeholder="请输入描述" />
        </FormItem>
        <FormItem label="封面图"
                  v-if="showHeadlineThumb">
          <upload-thumb v-model="headline.thumb"
                        ref="uploadthumb"
                        :defaultList="thumblist"
                        :autoCropWidth="690"
                        :autoCropHeight="390"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:690*390'"></upload-thumb>
        </FormItem>
        <FormItem label="相册"
                  v-if="showHeadlineImage">
          <upload-thumb v-model="headline.images"
                        ref="uploadthumbTwo"
                        :defaultList="thumblistTwo"
                        :autoCropWidth="200"
                        :autoCropHeight="200"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:200*200'"></upload-thumb>
        </FormItem>
        <FormItem label="上传视频"
                  :style="showHeadlineVideo ? 'display:block;' : 'display:none;'">
          <upload-video v-model="headline.video"
                        :defaultList="videolist"
                        ref="uploadvideo"></upload-video>
        </FormItem>
        <FormItem label="三方视频"
                  v-if="showHeadlineVideo">
          <Input type="textarea"
                 v-model="headline.other_video"
                 :rows="5"
                 placeholder="请输入第三方视频源码" />
        </FormItem>
        <FormItem label="内容"
                  :style="showHeadlineContent ? 'display:block;' : 'display:none;'">
          <!--          <editor-bar v-model="headline.content" :isClear="isClear" ref="editContent"></editor-bar>-->
          <UEditor v-model="headline.content"
                   ref="editContent"></UEditor>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer"
           v-if="showHeadlineTijiao">
        <Button style="margin-right: 8px"
                @click="showModalStatus = false">取消</Button>
        <Button type="primary"
                @click="createpushtype('headlineValidate')">提交</Button>
      </div>
    </Drawer>
    <!-- 审核弹框 -->
    <Form :model="headlinedata"
          action="javascript:void(0)">
      <Modal v-model="showHeadlineStatus"
             title="审核"
             @on-ok="reviewHeadline()"
             :loading="dataloading">
        <FormItem label="选择推荐类型"
                  label-position="top">
          <Select v-model="headlinedata.push_type"
                  clearable
                  filterable
                  placeholder="选择推荐类型">
            <Option v-for="item in pushtypelist"
                    :value="item.id"
                    :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="审核状态"
                  label-position="top">
          <RadioGroup v-model="headlinedata.status">
            <Radio label="0">待审核</Radio>
            <Radio label="1">通过</Radio>
            <Radio label="2">不通过</Radio>
          </RadioGroup>
        </FormItem>
      </Modal>
    </Form>
    <!-- 审核弹框 end -->
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
import uploadthumbTwo from "../common/thumb";
import UploadVideo from "../common/video";
import UEditor from "../common/ueditor";

export default {
  name: "headline-list",
  data () {
    return {
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      title: "",
      isClear: false,
      shengList: [],
      shiList: [],
      quList: [],
      showHeadlineTitle: false,
      showHeadlineDescibe: false,
      showHeadlineThumb: false,
      showHeadlineImage: false,
      showHeadlineVideo: false,
      showHeadlineContent: false,
      showHeadlineTijiao: true,
      loading: true,
      dataloading: true,
      formItem: {},
      thumblist: [],
      thumblistTwo: [],
      videolist: [],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      columns1: [
        {
          title: "Id",
          key: "id",
          width: 100,
          fixed: "left"
        },
        {
          title: "标题",
          key: "title",
          fixed: "left"
        },
        {
          title: "推荐类型",
          key: "push_type",
          fixed: "left"
        },
        {
          title: "分类",
          key: "cate_id",
          fixed: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.cate != "" && params.row.cate.name != ""
                  ? params.row.cate.name
                  : ""
              )
            ]);
          }
        },
        {
          title: "发布人",
          key: "admin_name",
          fixed: "left"
        },
        {
          title: "角色",
          key: "role",
          fixed: "left"
        },
        {
          title: "审核状态",
          key: "role",
          fixed: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {},
                params.row.status == "0"
                  ? "未审核"
                  : params.row.status == "1"
                    ? "审核通过"
                    : "未通过审核"
              )
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display: params.row.status == "0" ? "inline-block" : "none"
                  },
                  on: {
                    click: () => {
                      this.review(params.row.id);
                    }
                  }
                },
                "审核"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.showEditInfo(params.row.id);
                    }
                  }
                },
                "查看"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px",
                    display: params.row.status == "2" ? "inline-block" : "none"
                  }
                },
                "已拒绝"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      pushtypelist: [],
      statusList: [
        { id: 0, name: "未审核" },
        { id: 1, name: "审核通过" },
        { id: -1, name: "未通过审核" }
      ],
      catelist: [],
      headlinedata: {
        status: "0"
      },
      headline: {
        type: "0",
        is_push: "0"
      },
      showModalStatus: false,
      showHeadlineStatus: false,
      editor: {},
      headlineValidate: {}
    };
  },
  // 计算
  computed: {},
  components: {
    UploadThumb,
    uploadthumbTwo,
    UploadVideo,
    UEditor
  },
  // 监听
  watch: {},
  created: function () {
    //取推荐类型
    this.getPushTypeList();
    //取分类
    this.getCateList();
    // 取数据
    this.getTableList();
    this.getShengList();
  },
  methods: {
    getPushTypeList: function () {
      this.$api.headlinepush
        .list({
          page: 1,
          size: 100
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.pushtypelist = res.result.list;
          }
        });
    },
    getCateList: function () {
      this.$api.headlinecate.list().then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.catelist = res.result;
          // console.log(res.result);
        }
      });
    },
    getTableList: function () {
      var self = this;
      this.$api.headline
        .list({
          page: this.pages.page,
          size: this.pages.size
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            self.tablelist = res.result.list;
            self.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    // 切换头条展示形式
    headlinetype: function (val) {
      // 返回的是 lable值
      if (val == "0") {
        this.showHeadlineDescibe = true;
        this.showHeadlineImage = true;
        this.showHeadlineTitle = false;
        this.showHeadlineThumb = false;
        this.showHeadlineVideo = false;
        this.showHeadlineContent = false;
      } else if (val == "1") {
        this.showHeadlineDescibe = false;
        this.showHeadlineImage = false;
        this.showHeadlineTitle = true;
        this.showHeadlineThumb = true;
        this.showHeadlineVideo = true;
        this.showHeadlineContent = false;
      } else if (val == "2") {
        this.showHeadlineDescibe = false;
        this.showHeadlineImage = false;
        this.showHeadlineTitle = true;
        this.showHeadlineThumb = true;
        this.showHeadlineVideo = false;
        this.showHeadlineContent = true;
      }
    },
    // 展开添加
    showModel () {
      this.headlineid = 0;
      this.headline = {
        title: "",
        type: "0",
        is_push: "0",
        push_type: "",
        cate_id: "",
        describe: "",
        content: "",
      };
      this.showHeadlineDescibe = true;
      this.showHeadlineImage = true;
      this.showHeadlineTitle = false;
      this.showHeadlineThumb = false;
      this.showHeadlineVideo = false;
      this.showHeadlineContent = false;
      this.thumblist = new Array();
      this.thumblistTwo = new Array();
      this.videolist = [];
      // this.$refs["editContent"].editor.txt.html("");
      this.$refs["editContent"].message = "";
      this.$refs["headlineValidate"].resetFields();
      this.showModalStatus = !this.showModalStatus;
    },
    //展开修改
    showEditInfo: function (index) {
      this.headlineid = index;
      this.thumblist = new Array();
      this.thumblistTwo = new Array();
      this.videolist = [];
      this.showModalStatus = !this.showModalStatus;
      this.$api.headline.detail({ id: index }).then(res => {
        if (res.code == 200) {
          this.headline = res.result;
          this.headline.type = res.result.type.toString();

          if (this.headline.admin_id == "0") {
            this.showHeadlineTijiao = false;
          } else {
            this.showHeadlineTijiao = true;
          }
          //切换头条展示形式
          if (this.headline.type == "0") {
            this.showHeadlineDescibe = true;
            this.showHeadlineImage = true;
            this.showHeadlineTitle = false;
            this.showHeadlineThumb = false;
            this.showHeadlineVideo = false;
            this.showHeadlineContent = false;
          } else if (this.headline.type == "1") {
            this.showHeadlineDescibe = false;
            this.showHeadlineImage = false;
            this.showHeadlineTitle = true;
            this.showHeadlineThumb = true;
            this.showHeadlineVideo = true;
            this.showHeadlineContent = false;
          } else if (this.headline.type == "2") {
            this.showHeadlineDescibe = false;
            this.showHeadlineImage = false;
            this.showHeadlineTitle = true;
            this.showHeadlineThumb = true;
            this.showHeadlineVideo = false;
            this.showHeadlineContent = true;
          }

          if (this.headline.type == "2" && this.headline.content != "") {
            // this.$refs["editContent"].editor.txt.html(this.headline.content);
            this.$refs["editContent"].message = this.headline.content;
          }

          if (this.headline.thumb != null && this.headline.thumb != "") {
            this.thumblist.push({
              name: this.headline.thumb,
              url: this.headline.thumb,
              status: "finished"
            });
          }

          if (
            this.headline.images != "" &&
            this.headline.images != null &&
            this.headline.images.length > 0
          ) {
            for (var s in this.headline.attrShow) {
              this.thumblistTwo.push({
                name: this.headline.attrShow[s],
                url: this.headline.attrShow[s],
                status: "finished"
              });
            }
          }
          //展示视频路径
          if (this.headline.video != null && this.headline.video != "") {
            this.videolist.push({
              name: this.headline.video,
              url: this.headline.video,
              status: "finished"
            });
          }
          //省市区三个下拉框
          this.shiList = this.headline.shiList;
          this.quList = this.headline.quList;
        }
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      });
    },
    // 添加/修改
    createpushtype (name) {
      // 视频 和 图文 有封面图
      if (this.headline.type == "1" || this.headline.type == "2") {
        if (this.$refs["uploadthumb"].uploadList.length > 0) {
          this.headline.thumb = this.$refs["uploadthumb"].uploadList[0].url;
        } else {
          this.headline.thumb = null;
        }
      } else {
        this.headline.thumb = null;
      }

      // 图+文 有相册
      if (this.headline.type == "0") {
        if (this.$refs["uploadthumbTwo"].uploadList.length > 0) {
          var finalAttrs = "";
          var tList = this.$refs["uploadthumbTwo"].uploadList;
          for (var s in tList) {
            finalAttrs = finalAttrs + tList[s].url + ",";
          }
          if (finalAttrs != "") {
            this.headline.images = finalAttrs.substring(
              0,
              finalAttrs.length - 1
            );
          }
        } else {
          this.headline.images = null;
        }
      } else {
        this.headline.images = null;
      }
      // 视频 展示视频路径
      if (this.headline.type == "1") {
        // console.log(this.$refs["uploadvideo"].videoList);
        if (this.$refs["uploadvideo"].videoList.length > 0) {
          this.headline.video = this.$refs["uploadvideo"].videoList[0].url;
        } else {
          this.$Message.error('请上传视频');
          this.headline.video = null;
          return
        }
      } else {
        this.headline.video = null;
      }
      this.headline.content = this.$refs["editContent"].message;
      if (
        this.headlineid == null ||
        this.headlineid == 0 ||
        this.headlineid == undefined
      ) {
        this.$api.headline.create(this.headline).then(res => {
          if (res.code == 200) {
            this.showModalStatus = !this.showModalStatus;
            this.headline.name = "";
            this.getTableList();
          }
        });
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      } else {
        //编辑商品
        this.headline.id = this.headlineid;
        this.$api.headline.edit(this.headline).then(res => {
          if (res.code == 200) {
            this.getTableList();
            this.showModalStatus = false;
          }
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        });
      }
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        page: this.pages.page,
        size: this.pages.size,
        status: this.formItem.status,
        push_type: this.formItem.push_type
      };
      // console.log(ps);
      this.$api.headline.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    remove: function (index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.headline.remove({ id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.getTableList();
            }
          });
        }
      });
    },
    review: function (id) {
      this.headlineid = id;
      this.showHeadlineStatus = !this.showHeadlineStatus;
    },
    // 添加
    reviewHeadline: function (name) {
      this.$api.headline
        .status({ id: this.headlineid, status: this.headlinedata.status, push_type: this.headlinedata.push_type })
        .then(res => {
          if (res.code == 200) {
            this.getTableList();
          }
        });
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true;
      });
    },
    getShengList () {
      this.$api.intangibleItem.areaList({ id: 0 }).then(res => {
        if (res.code == 200) {
          this.shengList = res.result;
        }
      });
    },
    shengChange (value) {
      if (value != undefined) {
        this.$api.intangibleItem.areaList({ id: value }).then(res => {
          if (res.code == 200) {
            this.shiList = res.result;
          }
        });
      }
    },
    shiChange (value) {
      if (value != undefined) {
        this.$api.intangibleItem.areaList({ id: value }).then(res => {
          if (res.code == 200) {
            this.quList = res.result;
          }
        });
      }
    }
  }
};
</script>
